import { getBrowserLocales } from './getBrowserLocales';
import { getDomesticCurrency } from './currency';
import { SUPPORTED_LOCALES } from './constants';
import { getCurrencySymbol } from './currency';

const formatPrice = (price: string | number, options?) => {
  const browserLocales = getBrowserLocales();

  const domesticCurrency = getDomesticCurrency();
  const currencySymbol = getCurrencySymbol(domesticCurrency);

  if (typeof price === 'string') {
    return price;
  }

  const locale =
    !!browserLocales?.[0] && SUPPORTED_LOCALES.includes(browserLocales?.[0])
      ? browserLocales?.[0]
      : 'en-US';

  const value = typeof price === 'string' ? parseFloat(price) : Number(price);

  return Number.isFinite(value)
    ? value.toLocaleString(locale, {
        style: 'currency',
        currency: domesticCurrency,
        ...options,
      })
    : `${currencySymbol}0.00`;
};

export const formatCentsPrice = (price: string | number) => {
  const value = typeof price === 'string' ? parseFloat(price) : price;

  return formatPrice(value / 100);
};

export default formatPrice;
